export default "__VITE_ASSET__jfkBWR4G__"